import React from 'react';
import { Helmet } from 'react-helmet';
import config from 'sharedConfig';

export default function CategoryHeadTags(props) {
  const metaTitle = `${
    props.name
  } Delivery Near You - Online Delivery Near You | Saucey`;
  const title = props.title ? props.title : config.site.defaultTitle;
  const description = props.description
    ? props.description
    : config.site.defaultDescription;
  const url = [config.site.url, props.slug].join('/');

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
